export const BRANDING_PROMPT_IDS = {
  "csc-overview": "CSC-branding",
  ucx: "UCX-texts",
  "ao-overview": "AO-texts",
  foundry: "Foundry-texts",
  "firefly-enterprise": "Firefly-Enterprise-texts",
  "brand-visibility": "Brand-Visibility-texts",
  "brand-intelligence": "Brand-Intelligence-texts",
  ai: "AI-at-Adobe-texts",
  "partnership-value": "PV-texts",
  "cx-coworker": "CXCoworker-texts",
  "one-adobe": "One-Adobe-texts",
};

export const getCustomerBrandingPromptTemplate = ({
  templateId,
  customerName,
  hint,
  editScope,
  product,
  personaType,
}) => {
  const systemPromptId = Object.hasOwn(BRANDING_PROMPT_IDS, templateId)
    ? BRANDING_PROMPT_IDS[templateId]
    : undefined;
  if (!systemPromptId) return { template: [], systemPromptId };

  let userPrompt = "";
  if (templateId === "partnership-value") {
    userPrompt += `Write a partnership film script for Adobe and ${customerName}.\n\n`;
  }
  if (customerName) userPrompt += `[Company]: ${customerName}`;
  if (personaType) userPrompt += `\n[Persona-type]: ${personaType}`;
  if (product) userPrompt += `\n[Product]: ${product}`;
  if (hint) userPrompt += `\n\n[Hints]:\n${hint}`;
  if (editScope) userPrompt += `\n\n[Edit-scope]: ${editScope}`;

  return {
    systemPromptId,
    template: [{ role: "user", prompt_template: userPrompt }],
  };
};

// These are UI completion fields, not the model's response schema.
export const BRAND_LIBRARY_FIELDS = [
  "Brand-visual-DNA",
  ...Array.from({ length: 7 }, (_, index) => `Brand-library-prompt-${index + 1}`),
  "Competitor-brand-visual-DNA",
  "Competitor-library-prompt-1",
  "Competitor-library-prompt-2",
];
